/**
 * BecScComponent class
 * @param width - width
 * @param height - height
 * @param x - origin on x-axis
 * @param y - origin on y-axis
 * @param z - origin on z-axis
 * @constructor
 */
function BecScComponent(width, height, x, y, z, enabled) {
    this.width = width;
    this.height = height;
    this.x = x || 0;
    this.y = y || 0;
    this.z = z || 0;
    this.offsetX = 0;
    this.offsetY = 0;
    this.alzimuth = 0;
    this.tilt = 0;
    this.enabled = enabled || true;

    this.getVertices = function () {
        var offsetX = this.offsetX;
        var offsetY = this.offsetY;
        return [
            {x: 0, y: 0}, {x: width, y: 0}, {x: width, y: height}, {x: 0, y: height}
            ].map(function(item) {
                return {x: item.x + offsetX, y: item.y + offsetY};
            })
    };

    this.getOrigin = function () {
        return {x: this.x, y: this.y, z: this.z};
    };

    this.setOffset = function(x, y) {
        this.offsetX = x;
        this.offsetY = y;
        return this;
    };

    this.setAzimuth = function(val) {
        this.alzimuth = val;
        return this;
    };

    this.setTilt = function(val) {
        this.tilt = val;
        return this;
    };

    this.print = function() {
        var vertices = this.getVertices();
        return {
            origin: {x: this.x, y: this.y, z: this.z},
            azimuth: this.alzimuth,
            tilt: this.tilt,
            vertices: vertices.map(function(item) {
                return {x: item.x, y: item.y};
            }),
            enabled: this.enabled
        }
    }
}

module.exports = BecScComponent;



// WEBPACK FOOTER //
// ./src/redux/section/bec_sc_component.js